import React from "react";

export function PlatformNotice({ className = "" }) {
  return (
    <div className={`text-xs text-slate-600 leading-relaxed ${className}`} data-testid="platform-notice">
      ProSe.Claims is a technology platform operated by MISHERTECH. It is not a law firm and does not provide legal
      advice or representation. Information and documents produced through the platform may be incomplete or inaccurate
      and require independent review. Use of ProSe.Claims does not create an attorney-client relationship, and no
      outcome is promised or guaranteed.
    </div>
  );
}

export function MarketplaceNotice({ className = "" }) {
  return (
    <div className={`text-xs text-slate-600 leading-relaxed ${className}`} data-testid="marketplace-notice">
      Attorneys pay ProSe.Claims for platform access and lead-generation or advertising services. ProSe.Claims does not
      recommend, rank, select, or endorse attorneys. Representation begins only if the consumer and attorney enter into
      a separate agreement.
    </div>
  );
}
